import {Theme} from '@material-ui/core'

export const styles = (theme: Theme )=> ({
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap' as const,
    flex: 1,
    overflow: 'hidden',
    cursor: 'pointer',
  },
  noOptionsMessage: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  singleValue: {
    fontSize: 16,
    marginTop:-3,
  },
  placeholder: {
    position: 'absolute'as const,
    [theme.direction === 'rtl' ? 'right' : 'left']: 2,
    fontSize: 16,
  },
  paper: {
    position: 'absolute'as const,
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  grey: {
    color: theme.palette.secondary.main
  },
  spanBalance:{
    position: 'absolute'as const,
    [theme.direction === 'rtl' ? 'left' : 'right']: 50
  },
  spanBalanceRight:{
    position: 'absolute'as const,
    [theme.direction === 'rtl' ? 'left' : 'right']: 16
  },
  fontLight:{
    fontWeight: 300
  },
  // The dropdown row is a flex container, so this span defaults to
  // `min-width: auto` and its used width is the full unwrapped label line —
  // wider than the row. The money manager pill's `max-width: 100%` would then
  // resolve against that, never bind, and the pill would be cut mid-glyph by
  // MenuItem's overflow instead of ellipsised. Bounding the span fixes that.
  // Only the account option needs it: the balance is positioned against the
  // MenuItem, not this span, so nothing else about the row moves.
  optionAccount: {
    minWidth: 0,
  },
  menuItemRoot: {
    paddingTop: 10,
    paddingBottom: 10
  },
})
